/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  getQualityHistory(inboxId) {
    return axios.get(`${this.url}/${inboxId}/quality_history`);
  }

  getTemplateSendStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/template_send_status`);
  }

  getBusinessManager(inboxId) {
    return axios.get(`${this.url}/${inboxId}/business_manager`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  getAgentBotInbox(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot_inbox`);
  }

  setAgentBot(inboxId, botId, options) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
      ...options,
    });
  }
  
  pauseIngestion(inboxId, pauseUntil) {
    return axios.post(`${this.url}/${inboxId}/pause_ingestion`, {
      pause_until: pauseUntil,
    });
  }

  toggleStatus(accountId, inboxId, isActive) {
    return axios.patch(
      `/api/v1/accounts/${accountId}/inboxes/${inboxId}/toggle_status`,
      { is_inbox_active: isActive }
    );
  }

  getMultimediaCredentials(inboxId) {
    return axios.get(
      `${this.baseUrl()}/multimedia/credentials?inbox_id=${inboxId}`
    );
  }

  search(search = '', page = 1, limit = 20, sortAttr = 'name', include_subaccounts = false) {
    let requestURL = `${this.url}/search?q=${search}&page=${page}&limit=${limit}&sort=${sortAttr}&include_subaccounts=${include_subaccounts}`;
    return axios.get(requestURL);
  }
  getByAccount(accountId) {
    return axios.get(`/api/v1/accounts/${accountId}/inboxes`);
  }
}

export default new Inboxes();
